// import langs from "@/assets/data/langs";

// export default {
//     install(Vue, options) {
//         // 3. inject some component options
//         Vue.mixin({
//             // created() {}
//             methods: {
//                 test: function () {
//                     console.log('test');
//                 }
//             },
//         });

//         // 4. add an instance method
//         Vue.prototype.$langs = langs;
//         Vue.prototype.$langs.setLang = function () {
//             langs.lang = 'en';
//         }
//     }
// }

// lang-plugin.js (new version)
import Vue from 'vue';
import langs from "@/assets/data/langs";
import user from "@/services/user";
import { userConfig } from '@/services/constants';

export default {
  install(Vue, options) {
    Vue.prototype.$langs = new Vue({
      data() {
        const defaultLanguage = navigator?.languages?.includes('th') ? 'th' : 'en';
        return {
          currentLang: user.getConfig(userConfig.LANG) || defaultLanguage,
        };
      },
      methods: {
        switchLang() {
          this.currentLang = this.currentLang == 'en' ? 'th' : 'en';
          user.setConfig(userConfig.LANG, this.currentLang);
        },
        setLang(lang) {
          if (lang == 'en' || lang == 'th') {
            this.currentLang = lang;
            user.setConfig(userConfig.LANG, this.currentLang);
          } else {
            console.warn(`Language '${lang}' is not supported.`);
          }
        },
        get(key) {
          const keys = key.split('.');
          let value = langs;
          
          keys.forEach((k) => {
            if (value && value[k]) {
              value = value[k];
            } else {
              value = key;
            }
          });

          if (typeof value === 'undefined ') {
            return key;
          }
          return value?.[this.currentLang];
        },
        getFunc(key) {
          const value = this.get(key)
          if (typeof value === 'function') {
            return value
          }
          return function() {}
        }
      },
      computed: {
        lang() {
          return this.currentLang;
        },
      },
    });
  },
};
